module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-02.d63b59f4.png";